import CGVContent from './CGVContent';

export default CGVContent;
